import { render, staticRenderFns } from "./ManualTable.vue?vue&type=template&id=00ed8e93&scoped=true&"
import script from "./ManualTable.vue?vue&type=script&lang=ts&"
export * from "./ManualTable.vue?vue&type=script&lang=ts&"
import style0 from "./ManualTable.vue?vue&type=style&index=0&id=00ed8e93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ed8e93",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VSimpleTable,VTextField})
